type SingleSelectFieldOption = {
	value: string;
	id: string;
};

export const getSingleSelectFieldValue = ({
	defaultValue,
	allowedValues,
}: {
	defaultValue: unknown;
	allowedValues: unknown;
}): SingleSelectFieldOption | null => {
	if (
		(typeof defaultValue === 'string' || typeof defaultValue === 'number') &&
		Array.isArray(allowedValues)
	) {
		for (const isValue of allowedValues) {
			if (isValue.id === defaultValue.toString()) {
				return {
					value: isValue.value,
					id: isValue.id,
				};
			}
		}
		return null;
	}
	return null;
};
